// @flow

import React from 'react';
import { reduxForm, type FormProps } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Fieldset from '@clark-inc/clark-forms';
import { Button } from 'clark-styles';

import type { SessionStatusType } from 'types/sessions';
import formatCreateReport from 'containers/sessions/create/report/fieldset';
import { putSessionReport } from 'actions/sessions';
import Headline from './styles';

type PropsType = {
  clientName: string,
  sessionId: string,
  sessionStatus: SessionStatusType,
  dispatchPutSessionReport: typeof putSessionReport,
  showSessionReportRating: boolean,
} & FormProps;

const mapDispatchToProps = {
  dispatchPutSessionReport: putSessionReport,
};

const SessionsViewForm = ({
  submitting,
  pristine,
  clientName,
  handleSubmit,
  sessionId,
  sessionStatus,
  dispatchPutSessionReport,
  showSessionReportRating,
}: PropsType) => {
  const { FIELD_SETS } = formatCreateReport(
    sessionStatus === 'canceled',
    clientName,
    showSessionReportRating,
  );

  return (
    <form onSubmit={handleSubmit(formValues => dispatchPutSessionReport(sessionId, formValues))}>
      <Headline>Add notes about this session</Headline>
      <Fieldset data={FIELD_SETS} />
      <Button layout="fullWidth" disabled={pristine || submitting} type="submit">
        Save and send report
      </Button>
    </form>
  );
};

export default compose(
  connect(
    null,
    mapDispatchToProps,
  ),
  reduxForm({
    form: 'sessionReportCreate',
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
  }),
)(SessionsViewForm);



// WEBPACK FOOTER //
// ./src/containers/sessions/view-form/index.js